var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ProjectDiagram", {
    attrs: {
      network: _vm.diagramNetwork,
      options: { showLabels: _vm.showLabels },
      "show-labels": _vm.showLabels,
      allowDrag: !_vm.useNodesCoordinates,
    },
    on: {
      "update:network": function ($event) {
        _vm.diagramNetwork = $event
      },
      "update-breakers": _vm.updateBreakers,
      "click-switch": _vm.updateSwitch,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }